import SunCalc from "suncalc";
import { useState } from "react";

const MOON_PHASES = [
  "New Moon",
  "Waxing Crescent",
  "First Quarter",
  "Waxing Gibbous",
  "Full Moon",
  "Waning Gibbous",
  "Last Quarter",
  "Waning Crescent",
];

function getPhaseName(phase) {
  // SunCalc phase: 0=new, 0.25=first quarter, 0.5=full, 0.75=last quarter
  const idx = Math.round(phase * 8) % 8;
  return MOON_PHASES[idx];
}

export default function useMoonPhase(location) {
  const [refreshToggle, setRefreshToggle] = useState(0);

  const refresh = () => setRefreshToggle((c) => c + 1);

  try {
    const now = new Date(Date.now() + refreshToggle * 0);
    const illumination = SunCalc.getMoonIllumination(now);
    const fraction = Math.max(0, Math.min(1, illumination.fraction));
    const phase = Math.max(0, Math.min(1, illumination.phase));
    const waxing = phase <= 0.5;

    return {
      refresh,
      label: `${getPhaseName(phase)} ${Math.round(fraction * 100)}%`,
      name: getPhaseName(phase),
      fullness: fraction,
      phase,
      waxing,
      hasLocation: !!location,
      error: null,
      status: "good",
    };
  } catch (err) {
    console.error("Moon phase calculation failed:", err);
    return {
      refresh,
      label: "Unavailable",
      name: null,
      fullness: 0,
      phase: 0,
      waxing: true,
      hasLocation: !!location,
      error: "Unavailable",
      status: "warn",
    };
  }
}
